import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UserService {

  private apiUrl = `${environment.apiUrl}/api/user`;
  private championsDev = `${environment.championsProdUrl}/api/champions`;

    constructor(private http: HttpClient) {}

    searchCustomersList(
        searchText: string,
        pageNumber: number,
        pageSize: number
    ): Observable<any> {
        return this.http.get<any>(
            `${this.apiUrl}/search?searchText=${searchText}&pageSize=${pageSize}&pageNumber=${pageNumber}`
        );
    }

  listUsers(body: any): Observable<any>{
    return this.http.post(`${environment.championsProdUrl}/api/user/list-all`, body);
  }
}
